import React from 'react';
import styled, { css } from 'styled-components';
import {
  breakpointSizes,
  minBreakpointQuery,
  sectionMargins,
  greyColours,
  fontSize,
  fluidFontSize,
} from '../styles';
import { Container, Heading } from './ui';
import SpaCta from './SpaCta';
import { slugify } from '../utils';

const StyledSpaCtas = styled.section`
  ${sectionMargins(undefined, '70px')};
`;

const StyledHeader = styled.header`
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}

  ${({ isSpaCtaGroups }) => {
    if (!isSpaCtaGroups) {
      return css`
        margin-right: auto;
        margin-left: auto;
        max-width: 700px;
        text-align: center;
      `;
    }
  }}
`;

const StyledHeading = styled(Heading)`
  ${({ isSpaCtaGroups }) => {
    if (isSpaCtaGroups) {
      return css`
        display: flex;
        align-items: center;
        gap: 20px;
        ${fluidFontSize(
          '26px',
          '30px',
          breakpointSizes.tiny,
          breakpointSizes.xxlarge
        )};
        white-space: nowrap;

        ${minBreakpointQuery.large`
          gap: 30px;
        `}

        &:after {
          content: '';
          display: block;
          height: 1px;
          width: 100%;
          background-color: ${greyColours.lightGrey};
        }
      `;
    }
  }}
`;

const StyledText = styled.p`
  margin-top: 8px;
  line-height: 1.4;

  ${minBreakpointQuery.small`
    margin-top: 10px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 12px;
    ${fontSize(18)};
  `}
`;

const StyledItems = styled.div`
  display: grid;
  gap: 30px 20px;

  ${minBreakpointQuery.small`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.medium`
    row-gap: 40px;
  `}

  ${minBreakpointQuery.mlarge`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${minBreakpointQuery.large`
    row-gap: 50px;
  `}

  ${minBreakpointQuery.xlarge`
    row-gap: 60px;
  `}

  ${minBreakpointQuery.xxlarge`
    row-gap: 70px;
  `}
`;

const SpaCtas = ({ heading, text, items, affilateName, isSpaCtaGroups }) => (
  <StyledSpaCtas {...(isSpaCtaGroups && { id: slugify(heading) })}>
    <Container>
      <StyledHeader isSpaCtaGroups={isSpaCtaGroups}>
        <StyledHeading alt={true} isSpaCtaGroups={isSpaCtaGroups}>
          {heading}
        </StyledHeading>
        {text && <StyledText>{text}</StyledText>}
      </StyledHeader>
      <StyledItems>
        {items.map(
          (
            {
              image,
              logo,
              location,
              heading,
              subheading,
              text,
              minPrice,
              isPricePerPerson,
              link,
              url,
            },
            id
          ) => (
            <SpaCta
              key={id}
              image={image}
              logo={logo}
              location={location}
              heading={heading}
              subheading={subheading}
              text={text}
              minPrice={minPrice}
              isPricePerPerson={isPricePerPerson}
              link={
                link ||
                (url && {
                  text: 'View Details & Book',
                  url: url,
                })
              }
              affilateName={affilateName}
            />
          )
        )}
      </StyledItems>
    </Container>
  </StyledSpaCtas>
);

export default SpaCtas;
